export default "__VITE_ASSET__C6eyC45V__"